/**
 * EquipmentCard Component - Displays a single equipment card
 * @param {Object} props
 * @param {Object} props.equipment - Equipment data
 * @param {Function} props.onMoreDetails - Handler for viewing more details
 */
function EquipmentCard({ equipment, onMoreDetails }) {
  return (
    <div className="equipment-card">
      {/* Card Header with Timestamp */}
      <div className="card-timestamp">
        <span className="timestamp-text">Live Data</span>
      </div>

      {/* Equipment Title */}
      <div className="card-title">
        <h3>{equipment.name}</h3>
        <span className="instance-id">{equipment.instanceId}</span>
      </div>

      {/* Equipment Description */}
      <div className="equipment-description">
        <p>{equipment.description}</p>
      </div>

      {/* Equipment Details */}
      <div className="equipment-details">
        <div className="detail-row">
          <span className="detail-label">Asset:</span>
          <span className="detail-value">{equipment.assetId}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Industry:</span>
          <span className="detail-value">{equipment.industry}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Type:</span>
          <span className="detail-value">{equipment.type}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Parameters:</span>
          <span className="detail-value highlight">
            {equipment.parameters.length}
          </span>
        </div>
      </div>

      {/* Card Footer */}
      <div className="card-footer">
        <button className="details-btn" onClick={onMoreDetails}>
          Get Endpoints
        </button>
      </div>
    </div>
  );
}

export default EquipmentCard;
